export default {
  useDetail10: true,
};
